<template>
  <div>   
     <div class="semitransp">
   <b-jumbotron bg-variant="transparent" text-variant="white" class="border-top border-bottom border-warning">
    <template v-slot:header>Pergamin</template>

    <template v-slot:lead>
      Todas as suas tarefas em um mesmo lugar
    </template>

    <hr class="my-4">
    <div class="espacada">
    <p>
      <!--Integração empresarial. Inovação. Personalização. -->
      Uma solução em sistemas informatizados empresariais focada nas suas necessidades
    </p>
     </div>
   </b-jumbotron>
   </div>

         <div class="container-sm">
    <b-img center :src="require('../assets/imediata.svg')" fluid width="700rem" class="imagens" alt="Flechas indicando que há opções deImplementação imediata até Alta disponibilidade"></b-img>
    <p class="expl_fig">Disponível desde em um ambiente extremamente econômico com possibilidade para implementação imediata, até o desenvolvimento de site próprio e uso de servidores na empresa e remotos com alta disponibilidade, simultaneamente e de forma sincronizada.</p>
   </div>
   <div class="espacador"> </div>



      <div class="semitransp">
   <b-jumbotron bg-variant="transparent" text-variant="white" border-variant="dark">
    <!--<template v-slot:header> </template> -->
    <template v-slot:lead>
      É tudo online
    </template>
    <hr class="my-4">
    <div class="espacada">
    <p>
      Diretamente no navegador de internet. Sem instalação. Sem necessidade de computadores potentes ou sistema operacional específico. 
    </p>
    </div>
   </b-jumbotron>
   </div>


   <div class="container-sm" >
    <b-img center :src="require('../assets/site.png')" fluid width="400rem" class="imagens" alt="Design de site em verde e cinza"></b-img>
    <p class="expl_fig">Opção com criação e hospedagem de site exclusivo para a empresa.  </p>
   </div>
   <div class="espacador"> </div>


   <div class="semitransp">
   <b-jumbotron bg-variant="transparent" text-variant="white" border-variant="dark">
    <!--<template v-slot:header> </template> -->
    <template v-slot:lead>
      Base de dados protegida
    </template>
    <hr class="my-4">
    <div class="espacada">
    <p>
      Privacidade, segurança, registros e controle de acesso com autorizações individualizadas e por níveis. Base de dados para imagens e outros documentos. Proteção dos dados de acesso por criptografia.
    </p>
    </div>
   </b-jumbotron>
   </div>

  <div class="container-sm" >
    <b-img center :src="require('../assets/martelo.svg')" fluid width="400rem" class="imagens" alt="Ilustração de um martelo de juiz"></b-img>
    <p class="expl_fig"> Em conformidade com a Lei Geral de Proteção de Dados (LGPD) </p>
   </div>

<div class="semitransp"> <!--<p class="texttran">.  </p> -->
   <b-jumbotron bg-variant="transparent" text-variant="white" border-variant="dark">
    <!--<template v-slot:header> </template> -->
    <template v-slot:lead>
      Um sistema, vários dispositivos
    </template>
    <hr class="my-4">
    <div class="espacada">
    <p>
      Os sistemas Pergamin são pensados para serem acessados com comodidade por meio de diversos dispositivos, como computador, smartphone, tablet e SmartTV.
    </p>
    </div>
   </b-jumbotron> 
</div>

 <div class="carrossel carousel-inner">
     <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      fade
      background="#ababab"
      img-width="505"
      img-height="300"
      style="text-shadow: 1px 1px 2px #333;"
    >
          <!-- @sliding-start="onSlideStart" 
      @sliding-end="onSlideEnd" -->
      <!-- Slides with custom text -->
      <b-carousel-slide  :img-src="require('./../assets/carousel4.png')" img-alt="Visualização do sistema Pergamin Organic" >
        <h1 class="tituloslide">Pergamin Organic</h1>
      </b-carousel-slide>

      <!-- Slides with image only -->
      <b-carousel-slide :img-src="require('./../assets/carousel1.png')" img-alt="Visualização do sistema Pergamin Organic" >
      <h1 class="tituloslide">Pergamin Organic</h1>
      </b-carousel-slide>
      <b-carousel-slide :img-src="require('./../assets/carousel2.png')" img-alt="Visualização do sistema Pergamin Organic" >
      <h1 class="tituloslide">Pergamin Organic</h1>
      </b-carousel-slide>
      <b-carousel-slide :img-src="require('./../assets/carousel3.png')" img-alt="Visualização do sistema Pergamin Organic" >
      <h1 class="tituloslide">Pergamin Organic</h1>
      </b-carousel-slide> 
    </b-carousel>
    </div>


   <div class="espacador"> </div>

   <div class="semitransp">
   <b-jumbotron bg-variant="transparent" text-variant="white" class="border-top border-bottom border-warning">
    <!--<template v-slot:header> </template>       <h2 class="titulos">-->
    <template v-slot:lead>
      Pergamin Organic: diferentes funções interconectadas, como um organismo vivo.
    </template>
    <hr class="my-4">
    <div class="espacada">
    <p>
      Desenvolvido para clínicas, ambientes ambulatorial e hospitalar, o Pergamin Organic foi projetado para o futuro, com base em nossa ampla experiência, e com tecnologias inovadoras.
    </p>
    </div>
   </b-jumbotron>
   </div>

   <div class="container-sm" >
    <b-img center :src="require('../assets/hospital_4.png')" fluid width="400rem" class="imagens" alt="Desenho da fachada de um hospital"></b-img>
    <p class="expl_fig">Automação completa dos processos da sua clínica: agendamento, recepção e atendimento ao paciente, produção de laudos e entrega de resultados.</p>
   </div>

   <div class="espacador"> </div>

   <div class="semitransp">
   <b-jumbotron bg-variant="transparent" text-variant="white" border-variant="dark">
    <!--<template v-slot:header> </template> -->
    <template v-slot:lead>
      Facilita a administração financeira da sua clínica
    </template>
    <hr class="my-4">
    <div class="espacada">
    <p>
      Faturamento no padrão TISS com XML/webservice. Integração com sistemas de contabilidade. Emissão de Notas Fiscais eletrônicas, sem a necessidade de instalar certificado digital no computador (recurso atualmente disponível para Porto Alegre - consulte sobre outros locais).
    </p>
    </div>
   </b-jumbotron>
   </div>

   <div class="container-sm" >
    <b-img center :src="require('../assets/celular.png')" fluid width="120rem" class="imagens" alt="Desenho de um smartphone"></b-img>
    <p class="expl_fig"> Interação com o cliente via celular, para complementação de dados, avisos (SMS e aplicativos de mensagem instantânea). Acesso simples ao sistema por meio de smartphones e tablets, permitindo a visualização dos laudos. </p>
   </div>

   <div class="espacador"> </div>

   <div class="semitransp">
   <b-jumbotron bg-variant="transparent" text-variant="white" border-variant="dark">
    <!--<template v-slot:header> </template> -->
    <template v-slot:lead>
      Mais comodidade no exame médico e sua interpretação
    </template>
    <hr class="my-4">
    <div class="espacada">
    <p>
      Comunicação e interoperabilidade com equipamentos (tomógrafos, ecocardiógrafos, eletrocardiógrafos, entre outros) utilizando o padrão PACS/DICOM e Worklists, facilitando e simplificando o processo de realização e interpretação dos exames médicos. Produção de laudos com auxílio de dicionários e cálculos embutidos. Os laudos gerados podem ser assinados digitalmente pelo médico responsável.
    </p>
    </div>
   </b-jumbotron>
   </div>


   <div class="container-sm" >
    <b-img center :src="require('../assets/medica.svg')" fluid width="200rem" class="imagens" alt="Imagem ilustrativa de uma médica"></b-img>
    <p class="expl_fig"> Alguns exames como ECG, Holter e MAPA podem ser interpretados remotamente pelo médico, via sistema, trazendo mais segurança e comodidade aos profissionais.  </p>
   </div>

 <div class="espacador"> </div>
   <div class="semitransp">
   <b-jumbotron bg-variant="transparent" text-variant="white" border-variant="dark">
    <template v-slot:lead>
      Comodidade também para o paciente
    </template>
    <hr class="my-4">
    <div class="espacada">
    <p>
      Pode enviar para o paciente a chave para ver os resultados e laudos dos seus exames via e-mail. É possível o envio da chave dos resultados do exame também por aplicativo de mensagens instantâneas. 
    </p>
    </div>
   </b-jumbotron>
   </div>

  <div class="container-sm" > 
    <b-row text-center>
      <b-col>
    <b-img right :src="require('../assets/touca_mascara.svg')" fluid width="180rem" class="imagens" alt="Ilustração de um profissional de saúde com o EPI"></b-img></b-col>
    <b-col> <b-img left :src="require('../assets/sem_touca_mascara2.svg')" fluid width="180rem" class="imagens" alt="Ilustração de uma profissional de saúde sem o EPI"></b-img></b-col>
    </b-row>
    <p class="expl_fig"> Permite trabalho administrativo e de interpretação de exames presencial na clínica ou remoto, com sincronização em tempo real das operações. </p>
   </div>
  <div class="espacador"> </div>

     <div class="semitransp">
   <b-jumbotron bg-variant="transparent" text-variant="white" border-variant="dark">
    <template v-slot:lead>
      Validador TISS disponibilizado gratuitamente, sem necessidade de registro prévio
    </template>
    <hr class="my-4">
    <div class="espacada">
    <p>
      O <a href="https://www.pergamin.com.br/validar_TISS.php" class="validTISS">validador TISS</a> foi desenvolvido pela nossa empresa e pode ser utilizado gratuitamente (inclusive por você que ainda não usa o Pergamin Organic!) para validar documentos TISS. Também gera um relatório dos erros, se houver. Porém, quem implementa o sistema Pergamin Organic na sua empresa não precisa mais se preocupar com a validação de arquivos TISS! Essa operação é feita automaticamente em nosso sistema. 
    </p>
    </div>
   </b-jumbotron>
   </div>

   <div class="carrossel carousel-inner">
     <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      fade
      background="#ababab"
      img-width="505"
      img-height="300"
      style="text-shadow: 1px 1px 2px #333;"
    >
      <b-carousel-slide  :img-src="require('./../assets/nfpoa-tela01_corte.png')" img-alt="Visualização do sistema Pergamin nfpoa">
        <h1 class="tituloslide">Pergamin nfpoa</h1>
      </b-carousel-slide>
      <b-carousel-slide :img-src="require('./../assets/nfpoa-tela02_corte.png')" img-alt="Visualização do sistema Pergamin nfpoa">
      <h1 class="tituloslide">Pergamin nfpoa</h1>
      </b-carousel-slide>
      <b-carousel-slide :img-src="require('./../assets/nfpoa-tela03_corte.png')" img-alt="Visualização do sistema Pergamin nfpoa">
      <h1 class="tituloslide">Pergamin nfpoa</h1>
      </b-carousel-slide>
      <b-carousel-slide :img-src="require('./../assets/nfpoa-tela04_corte.png')" img-alt="Visualização do sistema Pergamin nfpoa">
      <h1 class="tituloslide">Pergamin nfpoa</h1>
      </b-carousel-slide> 
    </b-carousel>
    </div>



    <div class="espacador"> </div>



   <div class="semitransp">
   <b-jumbotron bg-variant="transparent" text-variant="white" class="border-top border-bottom border-warning">
    <template v-slot:lead>
      Pergamin nfpoa: solução desenvolvida para contabilistas
    </template>
    <hr class="my-4">
    <div class="espacada">
    <p>
      Solução para contabilistas e setores financeiro e contábil, para emissão de Notas Fiscais de Serviço Eletrônicas do município de Porto Alegre. O cálculo, totalização de impostos, geração de Guias de Pagamento (DARFs) e geração de arquivo de EFD para transmissão à Receita Federal é automático.
    </p>
    </div>
   </b-jumbotron>
   </div>

       <div class="container-sm" >
    <b-img center :src="require('../assets/lerqrcode.svg')" fluid width="180rem" class="imagens" alt="Smartphone lendo o QR Code do site Pergamin nfpoa"></b-img>
    <p class="expl_fig"> Uso de código QR para facilitar operações utilizando o smartphone. Se desejar, aponte sua câmera para o código QR acima para acessar a <a class="validTISS" href="https://nf.poa.br">homepage do Pergamin nfpoa</a>. </p>
   </div>
         <div class="espacador"> </div>

   <div class="semitransp">
   <b-jumbotron bg-variant="transparent" text-variant="white" border-variant="dark">
    <template v-slot:lead>
      Adaptado ao novo normal
    </template>
    <hr class="my-4">
    <div class="espacada">
    <p>
     Se desejado pelo cliente, o Pergamin nfpoa pode ser implantado remotamente, sem atividades presenciais, possibilitando o menor contato pessoal possível.
    </p>
    </div>
   </b-jumbotron>
   </div>

       <div class="container-sm" >
    <b-img center :src="require('../assets/notebook_pranc_sw2.svg')" fluid width="300rem" class="imagens" alt="Smartphone lendo o QR Code do site Pergamin nfpoa"></b-img>
    <p class="expl_fig"> Possibilita trabalho remoto por parte dos sócios e colaboradores </p>
   </div>
 




   

    <!-- <b-img center :src="require('../assets/pergamin_borrado.jpg')" fluid width="800rem" class="imagens"></b-img>
    <p class="expl_fig">Pergamin NSFePOA (trocar imagem)  </p> -->
   
   <div class="espacador"> </div>

   <div class="semitransp">
   <b-jumbotron bg-variant="transparent" text-variant="white" class="border-top border-bottom border-warning">
    <!--<template v-slot:header> </template> -->
    <template v-slot:lead>
      Pergamin Organic, nfpoa, ou outro, do tamanho da sua empresa
    </template>
    <hr class="my-4">
    <div class="espacada">
    <p>
      Adaptado às necessidades da sua empresa, com personalizações e adições disponíveis.
    </p>
    </div>
    <b-button size="lg" to="/opcoes" variant="outline-light">Veja as opções e entre em contato conosco</b-button>
   </b-jumbotron>
   </div>

   <div class="container-sm" >
    <b-img center :src="require('../assets/pergamin_logo_color2.svg')" fluid width="500rem" class="imagens" alt="Logo do Pergamin"></b-img>
    <!-- <p class="expl_fig"> Soluções para pronta utilização focadas em clínicas médicas e escritórios de contabilidade, mas que podem ser adaptadas às necessidades de seu negócio.   </p> -->
   </div>

   <div class="espacador"> </div>

   <div class="semitransp">
   <b-jumbotron bg-variant="transparent" text-variant="white" border-variant="dark"> <!--border-variant="dark"-->
    <!--<template v-slot:header> </template> -->
    <template v-slot:lead>
      Desenvolvido por quem entende de soluções informatizadas.
    </template>
    <hr class="my-4">
    <div class="espacada">
    <p>
      Pergamin é desenvolvido por Lucchese Computação e Estatística, por profissionais com mais de 30 anos de experiência em sistemas informatizados. Disponibilizamos suporte personalizado, com atenção e confiança.
    </p>
    </div>
    <b-button size="lg" href="http://lucchese.com.br" variant="outline-light">Visite-nos</b-button>
   </b-jumbotron>
   </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
body {
  background-image: url('../assets/background.jpg');
  background-attachment: fixed;
}
.barracor{
    background:  rgba(0, 0, 0, 0.8) ;
}
.barra{
    color: white;
}
.tituloslide{
  color: black;
  font-size: 1.5rem;
}
.carrossel{
  flex-grow:0;
  width: 60vw;
}
.carousel-inner{
  margin: auto;
}
.validTISS{
  color: gold;
}
.texttran{
  color: transparent;
}
.titulos{
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  font-size: 1.6rem;
}
</style>